export default "__VITE_ASSET__Btmmo30I__"